/**
 * Wikipedia API utility for fetching definitions
 */

export const fetchWikipediaDefinition = async (keyword) => {
    if (!keyword || typeof keyword !== 'string') {
        return null;
    }

    const url = `https://en.wikipedia.org/api/rest_v1/page/summary/${encodeURIComponent(keyword)}`;

    try {
        console.log(`🌐 Fetching from Wikipedia API: ${url}`);
        const response = await fetch(url, { 
            mode: 'cors',
            cache: 'default'
        });

        console.log(`📡 Wikipedia API response status: ${response.status}`);
        
        if (!response.ok) {
            if (response.status === 404) {
                console.log(`📭 Wikipedia page not found for: ${keyword}`);
                return null; // Page not found
            }
            throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();
        console.log(`📄 Wikipedia data received:`, { 
            title: data.title, 
            type: data.type, 
            hasExtract: !!data.extract,
            extractLength: data.extract?.length || 0 
        });
        
        // Skip disambiguation pages - they're not useful for definitions
        if (data.type === 'disambiguation') {
            console.log(`🔀 Skipping disambiguation page for: ${keyword}`);
            return null;
        }

        // Return clean definition data
        const result = {
            title: data.title,
            extract: data.extract,
            url: data.content_urls?.desktop?.page,
            type: data.type
        };
        
        console.log(`✨ Returning definition result:`, result);
        return result;

    } catch (error) {
        console.warn(`Failed to fetch definition for "${keyword}":`, error.message);
        return null;
    }
};

/**
 * Get the first sentence from a text extract
 */
export const getFirstSentence = (text) => {
    if (!text || typeof text !== 'string') {
        return '';
    }

    const sentences = text.split('. ');
    return sentences[0] + (sentences.length > 1 ? '.' : '');
};

/**
 * Clean and format definition text for display
 */
export const formatDefinitionText = (extract) => {
    if (!extract) return '';
    
    // Remove any remaining HTML tags
    let cleaned = extract.replace(/<[^>]*>/g, '');
    
    // Clean up extra whitespace
    cleaned = cleaned.replace(/\s+/g, ' ').trim();
    
    return cleaned;
};
